// Fits card text: titles shrink to one line (down to 72%; special products may use two lines); the
// origin/process/varietal line shrinks to three lines (down to 85%), then clamps with an ellipsis.
(() => {
  const STEP = 0.5;

  function lineHeight(el, size) {
    const lh = getComputedStyle(el).lineHeight;
    return lh === 'normal' ? size * 1.4 : parseFloat(lh);
  }

  function fitTitle(title) {
    title.style.fontSize = '';
    title.style.whiteSpace = 'nowrap';
    const base = parseFloat(getComputedStyle(title).fontSize);
    let size = base;
    while (title.scrollWidth > title.clientWidth + 1 && size > base * 0.72) {
      size -= STEP;
      title.style.fontSize = `${size}px`;
    }
    if (title.scrollWidth > title.clientWidth + 1) title.style.whiteSpace = 'normal';
  }

  function fitLines(el, lines, min, clampClass = 'ceto-clamp') {
    el.style.fontSize = '';
    el.classList.remove('ceto-clamp', 'ceto-clamp3');
    if (!el.textContent.trim()) return;
    const base = parseFloat(getComputedStyle(el).fontSize);
    let size = base;
    while (el.scrollHeight > lineHeight(el, size) * lines + 2 && size > base * min) {
      size -= STEP;
      el.style.fontSize = `${size}px`;
    }
    if (el.scrollHeight > lineHeight(el, size) * lines + 2) el.classList.add(clampClass);
  }

  function fitAll() {
    document.querySelectorAll('.ceto-card__title').forEach((t) => {
      if (t.closest('.ceto-card--plain')) {
        t.style.whiteSpace = '';
        fitLines(t, 2, 0.8);
      } else {
        fitTitle(t);
      }
    });
    document.querySelectorAll('.ceto-card__meta').forEach((el) => fitLines(el, 3, 0.85, 'ceto-clamp3'));
    document.querySelectorAll('.ceto-card__notes').forEach((el) => fitLines(el, 3, 0.85, 'ceto-clamp3'));
  }

  let timer;
  window.addEventListener('resize', () => {
    clearTimeout(timer);
    timer = setTimeout(fitAll, 150);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitAll);
  else fitAll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  window.addEventListener('load', fitAll);
  // cards that arrive later (related products, quick views) get fitted too
  new MutationObserver((records) => {
    if (records.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && n.querySelector && n.querySelector('.ceto-card__title')))) {
      clearTimeout(timer);
      timer = setTimeout(fitAll, 50);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
